/*
Loons Lab Table component
Developed By Roshan
Loons Lab
*/
import React, { useRef, useState, useEffect, useCallback } from 'react'
import MUIDataTable from 'mui-datatables'
import { merge } from 'lodash'
import { makeStyles } from '@mui/styles'

// Custom styles for table layout
const useStyles = makeStyles({
    tableRoot: {
        width: '100%',
        '& .MuiPaper-root': {
            width: '100% !important',
            boxSizing: 'border-box',
        },
        '& table': {
            width: '100% !important',
            tableLayout: 'fixed',
            borderCollapse: 'separate',
            borderSpacing: '0 12px', // <== Simulates row gap
        },
        '& .MuiTableHead-root': {
            backgroundColor: '#f5f5f5',
        },
        '& .MuiTableRow-root': {
            backgroundColor: '#fff',
            borderRadius: '1px',
            boxShadow: '0 1px 1px rgba(0,0,0,0.05)', // subtle shadow for separation
            overflow: 'hidden',
        },
        '& .MuiTableCell-root': {
            border: '1px solid #ccc',
            borderLeft: 'none',
            borderRight: 'none',
            padding: '16px',
        },
        '& .MuiTableCell-root:first-child': {
            borderLeft: '1px solid #ccc',
            borderTopLeftRadius: '1px',
            borderBottomLeftRadius: '1px',
        },
        '& .MuiTableCell-root:last-child': {
            borderRight: '1px solid #ccc',
            borderTopRightRadius: '1px',
            borderBottomRightRadius: '1px',
        },
         '& .MuiTableCell-root.MuiTableCell-body': {
            overflow: 'auto',
        },

        '& .MuiTableHead-root th, & .MuiTableHead-root .MUIDataTableHeadCell-data': {
  fontWeight: 'normal !important',
},

    },
})







const LoonsTable = (data) => {
    const classes = useStyles()
    const [isAlive, setIsAlive] = useState(true)
    const [userList, setUserList] = useState([])

    let drag = false
    let onTable = false
    const isDragging = useRef(false)
    const dragHeadRef = useRef()
    const [position, setPosition] = useState(0)

    const onMouseDown = useCallback((e) => {
        if (dragHeadRef.current && dragHeadRef.current.contains(e.target)) {
            isDragging.current = true
        }
    }, [])

    const onMouseUp = useCallback(() => {
        if (isDragging.current) {
            isDragging.current = false
        }
    }, [])

    const onMouseMove = useCallback((e) => {
        let tableele = document.getElementById(data.id)
        tableele.scroll(tableele.scrollLeft - e.movementX, 0)
    }, [])

    useEffect(() => {
        setUserList(data.data)

        let ele = document.getElementById(data.id + 'outer')
        let tableel = ele.getElementsByTagName('table')
        let tablebodyElement = tableel[0].closest('div')

        tablebodyElement.id = data.id
        tablebodyElement.classList.add('grabbable')

        document.addEventListener('mousedown', () => (drag = true))
        document.addEventListener('drop', () => (drag = false))
        document.addEventListener('mouseup', () => (drag = false))
        document.addEventListener('mousedown', () => (drag = true))
        document
            .getElementById(data.id)
            .addEventListener('mousemove', (e) => (drag ? onMouseMove(e) : null))
        document
            .getElementById(data.id)
            .addEventListener('dragover', (e) => (drag ? onMouseMove(e) : null))
    }, [onMouseMove, onMouseDown, onMouseUp])

    useEffect(() => {
        setUserList(data.data)
    }, [data])

    useEffect(() => {
        let ele = document.getElementById(data.id + 'outer')
        let tableel = ele.getElementsByTagName('table')
        let tablebodyElement = tableel[0].closest('div')

        tablebodyElement.id = data.id
        tablebodyElement.classList.add('grabbable')
    })

    return (
        <div id={data.id + 'outer'} style={{ width: '100%', overflowX: 'auto' }}>
            <div style={{ minWidth: '100%' }}>
                <MUIDataTable
                    title={data.title}
                    data={userList}
                    columns={data.columns}
                    options={merge({}, defaultOptions, data.options)}
                    className={classes.tableRoot}
                />
            </div>
        </div>

    )

}

const defaultOptions = {
    filterType: 'textField',
    sort: true,
    responsive: 'standard',
    selectableRows: 'none',
    search: false,
    filter: false,
    download: false,
    downloadOptions: {
        filterOptions: {
            useDisplayedColumnsOnly: true,
            useDisplayedRowsOnly: true,
        },
    },
    draggableColumns: {
        enabled: true,
    },
    print: false,
    pagination: false,
    viewColumns: false,
    elevation: 1,
    rowsPerPageOptions: [],
}

export default LoonsTable
